import { SENDLANE_LISTS } from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class SendlaneController extends AuthenticatedController {
  static async getLists(webhookId: number) {
    return super.get(SENDLANE_LISTS, {
      webhook_id: webhookId,
    });
  }
}
